//migrated libraries
import _ from 'lodash';
import autoBind from 'auto-bind';
import {Semaphore} from "async-mutex";

//migrated features
import shaders from './shaders';
import store from './store';
import AnnotationController from "./features/annotation/controller";
import EdgeService from "libs/edge-query/EdgeService";
import {AudioConferenceController} from "./features/audioConference/index";
import KinematicsController from './features/kinematics/controller'
import ARAnchoringController from "./features/ARAnchoring/controller";
import {DistanceController} from "./features/distanceController/index";
import {AvatarController} from "./features/avatar/index";
import {FeatureManagerController} from "./features/featureManager";
import {FeatureNameEnum} from "./features/featureManager/helper";
import {ChatBoxController} from "./features/chatbox/index";
import instance from "./features/onBoardTutorial/controller";
import keybindingController, {OperationEnum} from "./features/Keybindings/keybindingController";
import PCA from 'pca-js';
import ThrottledMouseMoveTask from "libs/throttled-mouse-move";
import socketIOInstance from "libs/socketIO/socketIO";
import Training from './features/training/base/training';
import TrainingService from "./features/training/service";
import AnimationPlayer from './features/training/animation/animationPlayer';
import Transformation from './features/training/animation/transformation';
import meshRestrictionController from "./features/meshRestriction/meshRestrictionController";
import meshRestrictionHelper from "./features/meshRestriction/meshRestrictionHelper";
import BaseMaterial from "./shaders/base-material/base-material";
import BoundaryService from "./services/boundary/boundary-service";
import UserNavigation from "./services/user-navigation/user-navigation";
import WorldBorderService from "./services/world-border/world-border-service";
import KeyboardMoveActionMap from "./services/user-navigation/keyboard-move-action";
import StandardDirection from "./services/user-navigation/standard-direction";
import {buttonController} from "./components/Buttons/index";
import SceneStateController from "./features/sceneStateManager/sceneStateController";
import {LobbyController} from "./features/lobby/index";
import EnvironmentController from "./features/EnvironmentFeature/controller";
import {buttonEnum} from "./components/Buttons/helper";
import {GenerateMeshBVHWorker} from 'libs/meshBVHWorker/GenerateMeshBVHWorker';
import MenuButtonParent from '../src/components/Buttons/VRMenu/menu-button-parent'
import VrButtonContainer from '../src/components/Buttons/VRMenu/vr-button-container'
import VolumeOpacity from '../src/features/model/volume-opacity'
import SceneMenuController from "./features/training/misc/scene-menu-controller";


import {VRMessageControllers, VRInformationControllers} from "./features/VRMessage/index";
import ActionController from "./features/training/action/action-controller";
import {ResourceTypeEnum} from "./features/training/base/training-literals";
import {userConfirmationManager} from "./features/user/UserConfirmationManager";
import ThreeMeshUI from 'libs/ThreeMeshUI/three-mesh-ui';
import {ActionTypeEnum} from "./features/training/base/training-literals";
import {GaussianSplatsManager} from "libs/GaussianSplats/gaussian-splat-manager";
import ResourceAuthoringController from "./features/training/authoring-resource/resource-authoring-controller";
import * as Icons from 'shared/assets/icons';
import {ARMarkers, TextureResolutionEnum} from "shared";
import Marker_QR from "shared/ARMarkers/marker_qr.png";
import Marker_Hiro from "shared/ARMarkers/marker_hiro.png";
import Marker_Alignment from "shared/ARMarkers/marker_alignment.png";
import StepInstructionScreenConfig from "./../../js/features/StepInstructionScreen/StepInstructionScreenConfig";
import { OverallMenuController, MenusTypeEnum } from "./../../js/features/Menu/overall-menu-controller";

//export to global
window._ = _;
window.stateStore = store;
window.AnnotationController = AnnotationController;
window.EdgeService = new EdgeService();
window.AudioConferenceController = AudioConferenceController;
window.KinematicsController = KinematicsController;
window.ARAnchoringController = ARAnchoringController;
window.VRMessageController = VRMessageControllers;
window.VRInformationController = VRInformationControllers;
window.DistanceController = DistanceController;
window.AvatarController = AvatarController;
window.FeatureManagerController = FeatureManagerController;
window.FeatureNameEnum = FeatureNameEnum;
window.ChatBoxController = ChatBoxController;
window.OnBoardTutorialController = instance;
window.PCA = PCA;
window.throttledMouseMoveTask = new ThrottledMouseMoveTask();
window.keybindingController = keybindingController;
window.OperationEnum = OperationEnum;
window.socketIOInstance = socketIOInstance;
window.Training = Training;
window.TrainingService = TrainingService;
window.AnimationPlayer = AnimationPlayer;
window.Transformation = Transformation;
window.meshRestrictionController = meshRestrictionController;
window.meshRestrictionHelper = meshRestrictionHelper;
window.shaders = shaders;
window.BaseMaterial = BaseMaterial;
window.BoundaryService = BoundaryService;
wv.userNavigation = new UserNavigation();
window.WorldBorderService = WorldBorderService;
window.KeyboardMoveActionMap = KeyboardMoveActionMap;
window.StandardDirection = StandardDirection;
window.buttonController = buttonController;
window.SceneStateController = SceneStateController;
window.EnvironmentController = EnvironmentController;
window.ActionController = ActionController;

window.autoBind = autoBind;
window.LobbyController = LobbyController;
window.Semaphore = Semaphore;
window.buttonEnum = buttonEnum;
window.meshBVHWorker = new GenerateMeshBVHWorker();
window.MenuButtonParent = new MenuButtonParent();
window.VrButtonContainer = new VrButtonContainer();
window.VolumeOpacity = new VolumeOpacity();
window.ResourceTypeEnum = ResourceTypeEnum;
window.userConfirmationManager = userConfirmationManager;
window.ThreeMeshUI = ThreeMeshUI;
window.ActionTypeEnum = ActionTypeEnum;
window.GaussianSplatsManager = new GaussianSplatsManager();
window.ResourceAuthoringController = ResourceAuthoringController;
window.Icons = Icons;
window.SceneMenuController = SceneMenuController;
window.ARMarkers = ARMarkers;
window.TextureResolutionEnum = TextureResolutionEnum;
window.ARMarkerImages = {
    "marker_alignment": Marker_Alignment,
    "marker_qr": Marker_QR,
    "marker_hiro": Marker_Hiro,
};
window.StepInstructionScreenConfig = StepInstructionScreenConfig;
window.OverallMenuController = OverallMenuController;
window.MenusTypeEnum = MenusTypeEnum;

//let post initialization begin
document.dispatchEvent(new CustomEvent('bootstrap_completed'));
